import { environment } from '../../environments/environment';

export type CompanyKey = 'hudklinikken' | 'sav' | 'aph';

/** Ids differ per environment. A company missing from the environment config is never matched, so its features stay off. */
const COMPANY_IDS: Partial<Record<CompanyKey, number>> = environment.companyIds;

export function isCompany(key: CompanyKey, companyId: number | undefined): boolean {
  const configuredId = COMPANY_IDS[key];
  return configuredId !== undefined && configuredId === companyId;
}
